import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { TextField, Typography, Button, Grid} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { AcquirerActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const acquirersSelector = (state) => state.Acquirers;
const IdentitySelector = (state) => state.Identity;

const AcquirerStepOne = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(acquirersSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch } = useForm();

    const { classes } = props;

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        return value;
    }

    //next button
    const handleNext = () => {
        props.handleNext();
    };

    //back button
    const handleBack = () => {
        props.handleBack();
    };

    // submitボタンのアイコンとタイトルを画面に応じて変更
    var submitIcon;
    var submitTitle;
    if (props.mode == "regist") {
        // 登録時：次へ
        submitIcon = <ArrowForwardIosIcon />;
        submitTitle = <FormattedMessage id="Button.Next" />;
    }
    else {
        // 更新時：入力し内容に変更
        submitIcon = <SaveIcon />;
        submitTitle = <FormattedMessage id="Button.Update" />;
    }

    return (
        <form className={classes.form} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Controller
                        name="contact_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.contact_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerContactNameMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.contact_name && true}
                            helperText={errors.contact_name ? errors.contact_name.message : "例）沖縄太郎"}
                            label={<FormattedMessage id={"Merchant.FullName"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="contact_f_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.contact_f_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerContactNameMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[ァ-ヶー０-９]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.KatakanaName" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.contact_f_name && true}
                            helperText={errors.contact_f_name ? errors.contact_f_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} オキナワタロウ</Typography>}
                            label={<FormattedMessage id={"Merchant.FullNameFurigana"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="contact_tel"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.contact_tel}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 10, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerTelMinLenPattern" />}</Typography>},
                            maxLength: { value : 12, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerTelMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.contact_tel && true}
                            type="number"
                            helperText={errors.contact_tel ? errors.contact_tel.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0975768181</Typography>}
                            label={<FormattedMessage id={"Merchant.PhoneNumber"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="mail_adress"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.mail_adress}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 256, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerEmailMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Email" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.mail_adress && true}
                            type="email"
                            helperText={errors.mail_adress ? errors.mail_adress.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} abcd@xxxx.com</Typography>}
                            label={<FormattedMessage id={"Merchant.Mail"} />} />} />
                </Grid>

                <Grid item xs={12}>
                    <Controller
                        name="contact_depart"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.contact_depart}
                        rules={{
                            maxLength: { value: 40, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerContactDepartMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.contact_depart && true}
                            helperText={errors.contact_depart ? errors.contact_depart.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 営業部</Typography>}
                            label={<FormattedMessage id={"Merchant.Department"} />} />} />
                </Grid>

                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={handleSubmit(handleNext)}
                        endIcon={submitIcon}>
                        {submitTitle}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(AcquirerStepOne);
